import React from 'react';
import HomeCard from "./HomeCard";

const HomeUserProfileContent = () => {
    return (
        <HomeCard>
            <h3 className="text-2xl font-semibold mb-6">User Profile</h3>
            {/* Add user profile form fields here */}
        </HomeCard>
    );
};

export default HomeUserProfileContent;
